import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {environment} from "../../../environments/environment";
declare let drift;
@Component({
  selector: 'app-home',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
  private isOpen = false;
  tabs: Array<any> = [{active: true}, {active: false}, {active: false}];
  devDocUrl: string = environment.devDocUrl;

  constructor(
  ) { }

  ngOnInit() {
    if (drift) {
      drift.on('ready', function (api, payload) {
        api.widget.show();
        api.openChat();
      });
    }
  }
    selectTab(index: number) {
      // deactivate all tabs
      this.tabs.forEach(tab => tab.active = false);

      // activate the tab the user has clicked on.
      this.tabs[index].active = true;
    }




}



// WEBPACK FOOTER //
// ./src/app/site/home/home.component.ts